import { render, staticRenderFns } from "./ListarDistribuicao.vue?vue&type=template&id=e4414f28"
import script from "./ListarDistribuicao.vue?vue&type=script&lang=js"
export * from "./ListarDistribuicao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports